import { useStore } from '@/store';
import { presets } from '@utils/dependencyLoader/loader/preset-loader';
import useDepLoader from '@composables/useDepLoader';
import dependencyLoader from '@/utils/dependencyLoader';
import { onUnmounted } from '@vue/composition-api';
export const handleAiPageConfig = (externals) => {
    const dependencies = new Set();
    externals.forEach((dependency) => {
        if (dependency.startsWith('@wuji-go')) {
            return;
        }
        if (presets.includes(dependency)) {
            return;
        }
        dependencies.add(dependency);
    });
    return dependencies;
};
// AI页面统一用这个字段作为依赖
const AI_PAGE_ID = 'wuji-ai-page_deps';
const FETCH_PREVIEW_DEPENDENCY_TYPE = '__fetch_preview_dependency__';
const EDITOR_UPDATE_DEPENDENCY_TYPE = '__editor-update-dependency__';
const useAiDepLoader = () => {
    const { updateDependency, loadDependencies } = useDepLoader();
    const loadAIPageDependency = async (runtime = false) => {
        const store = useStore();
        const dependency = runtime ? store.state.runtime.project.dependency : store.state.project.projectInfo.dependency;
        const externals = dependency?.pages?.[AI_PAGE_ID] || [];
        await loadDependencies(handleAiPageConfig(externals));
        return new Promise((resolve) => {
            /**
             * 预览模式下，依赖可能会被更新
             * 这个时候我们向编辑器发送消息，让编辑器更新依赖
             *
             * 这个通讯是一次性的，接受到消息后就会关闭通道
             */
            const searchParams = new URLSearchParams(window.location.search);
            const isPreview = searchParams.get('wujiAiPageUK');
            if ((window.opener || window.parent || window.top) && isPreview) {
                const channel = new MessageChannel();
                (window.opener || window.parent || window.top)?.postMessage({
                    type: FETCH_PREVIEW_DEPENDENCY_TYPE,
                    port: channel.port2,
                }, '*', [channel.port2]);
                channel.port1.onmessage = (e) => {
                    if (e.data.type === EDITOR_UPDATE_DEPENDENCY_TYPE) {
                        const { bundle, dependencies } = e.data;
                        dependencyLoader.updatePreviewDeps({
                            bundle,
                            dependencies,
                        }).then(() => {
                            resolve(true);
                        });
                    }
                    channel.port1.close();
                };
                channel.port1.start();
            }
            else {
                resolve(true);
            }
        });
    };
    const updateAIPageDependency = (externals) => {
        const dependencies = handleAiPageConfig(externals);
        return updateDependency(dependencies, AI_PAGE_ID);
    };
    return {
        loadAIPageDependency,
        updateAIPageDependency,
    };
};
export const useEditorDepLoader = () => {
    /*
    * 监听预览模式下，编辑器发送的依赖更新消息
    * 并更新依赖
    */
    const handleMessage = (e) => {
        if (e.data.type === FETCH_PREVIEW_DEPENDENCY_TYPE) {
            const { port } = e.data;
            const { bundle, dependencies } = dependencyLoader.getPreviewDepInfo();
            port.postMessage({
                type: EDITOR_UPDATE_DEPENDENCY_TYPE,
                bundle,
                dependencies,
            });
        }
    };
    window.addEventListener('message', handleMessage);
    onUnmounted(() => {
        window.removeEventListener('message', handleMessage);
    });
};
export default useAiDepLoader;
